import { AppData, Lightning, Log, Utils } from '@lightningjs/sdk'
import axios from 'axios'
import { AppSetup } from '../lib/app-setup'
import WebpTexture from '../ui-textures/wepp-texture'

export interface FalllbackImageTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class FallbackImage
    extends Lightning.Component<FalllbackImageTemplateSpec>
    implements Lightning.Component<FalllbackImageTemplateSpec> {

    _isResouce = false
    static fallBackUrls:Set<string> = new Set([])

    static override _template(): Lightning.Component.Template<FalllbackImageTemplateSpec> {
        return {
            w: (w: any) => w,
            h: (h: any) => h,
            ImgWrapper: {
                w: (w: any) => w,
                h: (h: any) => h,
                src: ''
            }
        }
    }

    set isResouce(isResource: boolean) {
        this._isResouce = isResource
    }

    set imgSrc(url: string) {
        if(url !== '') {
            this._loadImage(url)
        }
    }

    async _loadImage(url: string) {
        const { appConfig } = AppData as AppSetup
        const cdnUrl = `${this._isResouce ? appConfig?.resouceUrl + url : Utils.asset(url)}`
        let hostedUrl = `${this._isResouce ? appConfig?.backupResourceUrl : appConfig?.backupStaticUrl}${url}`
        let inFallbackArray = FallbackImage.fallBackUrls.has(hostedUrl)

        
            if(inFallbackArray) {
                this._update(hostedUrl)
            } else {
                try {
                    const response = await axios.head(cdnUrl, {timeout: 1200})
                    if (response.status >= 200 && response.status < 300) {
                        this._update(cdnUrl)
                    } else {
                        Log.error('Error loading image from CDN URL:', cdnUrl, response.status)
                        FallbackImage.fallBackUrls.add(hostedUrl)
                        this._update(hostedUrl)
                    }
                } catch (error) {
                    Log.error('Error loading image from CDN URL:', cdnUrl, error)
                    FallbackImage.fallBackUrls.add(hostedUrl)
                    this._update(hostedUrl)
                }
            }
            
        
    }

    _update(path:string) {
        this.patch({
            ImgWrapper: {
                texture:{
                    type: WebpTexture,
                    src: path 
                } 
            }
        })  
    }
}